module.exports = __webpack_public_path__ + "img/grey.625ae0ec.svg";